module.exports = __webpack_public_path__ + "img/model1.c1c6de39.png";